import React from "react";
import { Redirect, Route, RouteProps } from "react-router";
import { AppRouteUi } from "../config/appRoute";
import { AppUserRoles } from "../config/constants";
import { useAppSelector } from "../core/redux";

type Props = RouteProps & {
  role?: AppUserRoles | AppUserRoles[];
};

const Fallback = () => <Redirect to={AppRouteUi.NotFound.Root()} />;

export function PrivateRoute({ role, ...routeProps }: Props): JSX.Element {
  const userRole = useAppSelector((state) => state.auth.userRole);
  const isRoleMatch = React.useMemo(() => {
    if (!userRole) return true;

    if (Array.isArray(role)) {
      return role.includes(userRole);
    } else {
      return role === userRole;
    }
  }, [role, userRole]);

  return (
    <Route
      {...routeProps}
      component={isRoleMatch ? routeProps.component : Fallback}
      render={isRoleMatch ? routeProps.render : undefined}
    />
  );
}
